<template>
  <div class="expense-list-page">
    <van-nav-bar
      title="报销-管理摊分"
      left-arrow 
      fixed
      @click-left="onClickLeft"
    />

    <div class="content-wrapper">
      <van-loading v-if="loading" type="spinner" size="40" vertical style="padding: 60px 0;">
        加载中...
      </van-loading>

      <div v-else class="list-container">
        <div 
          v-for="item in tableDataList"
          :key="item.IDSEQ"
          class="expense-card"
          @click="viewDetail(item)"
        >
          <div class="card-header">
            <div class="card-number-wrapper">
              <span class="card-id">{{ item.IDNO }}</span>
            </div>
            <div class="card-status" :class="getStatusClass(item.STFG)">
              {{ getStatusText(item.STFG) }}
            </div>
          </div>
          
          <div class="card-body">
            <div class="card-row">
              <span class="label">发起人：</span>
              <span class="value">{{ item.APPUSER }}</span>
            </div>
            <div class="card-row">
              <span class="label">单据日期：</span>
              <span class="value">{{ item.DTTM }}</span>
            </div>
            <div class="card-row">
              <span class="label">单据简要描述：</span>
              <span class="value">{{ item.TITLE || '无' }}</span>
            </div>
          </div>
        </div>

        <div v-if="tableDataList.length === 0" style="padding: 40px 0; text-align: center; color: #969799;">
          <van-icon name="warning-o" size="48" color="#dcdee0" />
          <div style="margin-top: 16px; font-size: 14px;">暂无待审批数据</div>
        </div>
      </div>
    </div>

    <div class="pagination-wrapper" v-if="v_total > rowSize">
      <van-pagination 
        v-model="currentPage" 
        :total-items="v_total" 
        :items-per-page="rowSize" 
        :show-page-size="5" 
        force-ellipses 
        @change="changePage"
      >
        <template #prev-text>
          <van-icon name="arrow-left" />
        </template>
        <template #next-text>
          <van-icon name="arrow" />
        </template>
        <template #page="{ text }"> {{ text }} </template>
      </van-pagination>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ExpenseList',
  data() {
    return {
      v_usernm: this.$cookies.get('v_usernm'),
      v_username: this.$cookies.get('v_telno'),
      v_corpid: this.$cookies.get('v_corpid'),
      expenseList: [],
      tableDataList: [],
      loading: false,
      currentPage: 1,
      v_total: 0,
      rowSize: 5,
    }
  },

  mounted() {
    // 优先使用从 Dashboard 传过来的数据
    if (this.$route.params.expenseData && this.$route.params.expenseData.length > 0) {
      this.expenseList = this.$route.params.expenseData
      this.initPage()
    } else {
      // 如果没有传递数据（比如直接访问这个页面），则重新加载
      this.loadExpenseList()
    }
  },
  methods: {
    // 加载报销列表（备用方法）
    loadExpenseList() {
      this.loading = true
      let v_chk =' or (ty=\'RECEIVE\' and chkdttm is null and appuser=\''+this.v_username+'\') '+' or (ty=\'SKUFEE\' and appdttm is null and telno1=\''+this.v_username+'\') '+' or (ty=\'SKUFEE\' and chkdttm is null and telno2=\''+this.v_username+'\') '
      v_chk =v_chk+' or (ty=\'CONFIRM\' and ((nodttm1 is null and telno1=\''+this.v_username+'\') or (nodttm2 is null and telno2=\''+this.v_username+'\') or (nodttm3 is null and telno3=\''+this.v_username+'\') or (nodttm4 is null and telno4=\''+this.v_username+'\') or (nodttm5 is null and telno5=\''+this.v_username+'\')))'
      let v_cond ='select * from V_WAIT_CONFIRM a where a.corpid=\''+this.v_corpid+'\' and ((ty=\'FREE\')'+v_chk+' OR exists(select null from V_CHKUSER where fruser is null and chkuser1=\''+this.v_username+'\' and ty=a.ty AND TY!=\'FINFEE\') or exists(select null from V_FLOW_CFM where idseq=a.idseq and userno=\''+this.v_username+'\') )'
      this.$axios({
        method: 'post',
        url:'xuper_auth/getFreeData',
        data: {p_cond: v_cond +' order by seq,idty,dttm desc'},
      }).then(res => {
        if (res.code === '200') {
          const allData = res.result || []
          this.expenseList = allData.filter(item => item.IDTY === '报销-管理摊分')
          this.initPage()
        }
      }).catch(err => {
        this.$toast.fail('加载数据失败')
      }).finally(() => {
        this.loading = false
      })
    },

    initPage() {
        this.v_total =this.expenseList.length //总条数
        if (this.expenseList.length < this.rowSize){
          this.tableDataList = this.expenseList
        }else{
          this.tableDataList =this.expenseList.slice(0,this.rowSize) //返回选定元素的子数组，不包含结尾元素
        }
    },
    // 查看详情
    viewDetail(item) {
      console.log('查看详情',item)
      this.$router.push({
        name: 'ExpenseDetail',
        params: { 
          itemData: item
        }
      })
    },

    // 返回
    onClickLeft() {
      // 返回到审批管理首页
      this.$router.push('/approval')
    },

    // 获取状态样式类
    getStatusClass(status) {
      const classMap = {
        'N': 'status-pending',
        'Y': 'status-approved',
        'X': 'status-rejected'
      }
      return classMap[status] || 'status-pending'
    },

    // 获取状态文本
    getStatusText(status) {
      const textMap = {
        'N': '待审批',
        'Y': '已通过',
        'X': '已拒绝'
      }
      return textMap[status] || '待审批'
    },
    changePage() {
      const startIndex = (this.currentPage - 1) * this.rowSize
      const endIndex = startIndex + this.rowSize
      this.tableDataList = this.expenseList.slice(startIndex, endIndex)
    }
  }
}
</script>

<style lang="scss" scoped>
.expense-list-page {
  display: flex;
  flex-direction: column;
  height: 100%;
  background: #f7f8fa;
}

.content-wrapper {
  flex: 1;
  overflow-y: auto;
  margin-top: 46px;
  margin-bottom: 46px;
  padding: 12px;
}

.list-container {
  .expense-card {
    background: #fff;
    border-radius: 12px;
    padding: 16px;
    margin-bottom: 12px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
    cursor: pointer;
    transition: all 0.3s;

    &:active {
      transform: scale(0.98);
    }

    .card-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 12px;
      padding-bottom: 12px;
      border-bottom: 1px solid #f0f0f0;

      .card-number-wrapper {
        display: flex;
        align-items: center;

        .card-id {
          font-size: 16px;
          font-weight: 600;
          color: #333;
        }
      }

      .card-status {
        padding: 4px 12px;
        border-radius: 12px;
        font-size: 12px;
        font-weight: 500;

        &.status-pending {
          background: #fff3e0;
          color: #ff9800;
        }

        &.status-approved {
          background: #e8f5e9;
          color: #4caf50;
        }

        &.status-rejected {
          background: #ffebee;
          color: #f44336;
        }
      }
    }

    .card-body {
      .card-row {
        display: flex;
        margin-bottom: 8px;
        font-size: 14px;
        line-height: 1.6;

        &:last-child {
          margin-bottom: 0;
        }

        .label {
          color: #969799;
          min-width: 90px;
        }

        .value {
          color: #333;
          font-weight: 600;
          flex: 1;

          &.amount {
            color: #f44336;
            font-weight: 600;
          }
        }
      }
    }
  }
}

.pagination-wrapper {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  height: auto;
  background: #fff;
  border-top: 1px solid #f0f0f0;
  padding: 12px;
  display: flex;
  justify-content: center;
  z-index: 10;
}
</style>
